"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _meeting["default"];
  }
});
var _meeting = _interopRequireDefault(require("./meeting"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }